<template>
    <BaseNotification v-if="missing" theme="info" :text="notice" hide-dismiss />
</template>

<script setup lang="ts">
import type { CycleView } from "~vue/AssessmentResults/types";
import BaseNotification from "~vue/components/BaseNotification.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { cycle, viewerIsSubject } = defineProps<{
    cycle: CycleView;
    viewerIsSubject: boolean;
}>();

const { t } = useI18n();

// Rendered only once a report exists. A report without the subject's own
// reflection has no self scores to compare against, whether the window closed
// on it or the subject chose to generate without it; the cycle may still read
// as unlocked until the next close sweep, so the state is not the signal.
const missing = computed(() => cycle.self_assess_enabled && !cycle.self_assessment_submitted && !cycle.is_self_assessment_only);
const notice = computed(() =>
    viewerIsSubject ? t("reflections.results.selfReflectionMissingSubject") : t("reflections.results.selfReflectionMissingTeamLead", { name: cycle.subject_first_name }),
);
</script>
